import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const InkPorcelainOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;
  const buttonGlow = 15 + Math.sin((frame / fps) * Math.PI * 1.5) * 10;

  return (
          <div
            style={{
              width: "100%",
              padding: "50px 40px",
              background: "rgba(9, 12, 16, 0.85)", // dark translucent slate
              border: "1.5px solid rgba(1, 150, 175, 0.25)", // teal glass border
              borderRadius: "24px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: "30px",
              boxShadow: "0 20px 45px rgba(0, 0, 0, 0.5), 0 0 20px rgba(1, 150, 175, 0.1)",
            }}
          >
            <div
              style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "12px",
                fontWeight: 700,
                color: "#0196AF", // teal
                letterSpacing: "6px",
                textTransform: "uppercase",
              }}
            >
              ✦ Stay Briefed ✦
            </div>
            <h2
              style={{
                fontFamily: "'Playfair Display', serif",
                fontStyle: "italic",
                fontSize: "48px",
                fontWeight: 700,
                lineHeight: 1.25,
                color: "#fdfffc", // porcelain/white for high contrast on dark bg
                margin: 0,
                textShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
              }}
            >
              Never Miss An Intel Brief
            </h2>
            <div
              style={{
                transform: `scale(${pulseScale})`,
                background: "#F45E2E", // orange
                padding: "18px 40px",
                borderRadius: "50px",
                boxShadow: `0 0 ${buttonGlow}px rgba(244, 94, 46, 0.4)`,
              }}
            >
              <span
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 800,
                  fontSize: "24px",
                  color: "#fdfffc", // porcelain
                  letterSpacing: "1px",
                }}
              >
                👉 Follow for More
              </span>
            </div>
            <div
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "24px",
                fontWeight: 600,
                color: "#0196AF", // teal handle for branding
              }}
            >
              {keywords?.[1] || "@TheDigitalBullet"}
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
